import { getCookie } from "../utils/cookies";

export function checkAuth(): string | null {
  const user = getCookie("user");
  if (user !== "") {
    return user;
  } else {
    return null;
  }
}
